import { useNavigate } from '@hulu/react-router-dom';
import { Auth } from 'aws-amplify';
import React, { useEffect } from 'react';

import Footer from '../../components/Footer';
import { AdminRoutePath, RoutePath } from '../../constants';
import {
  ContentContainer,
  GoToHomeButton,
  NotFoundIcon,
  NotFoundPageInnerContainer,
  NotFoundPageOuterContainer,
  NotFoundPageSubTitle,
  NotFoundPageTitle,
} from './styled';

type Props = {
  isAdmin?: boolean;
};

const NotFound = ({ isAdmin = false }: Props): JSX.Element => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      Auth.currentSession().catch(() => navigate(RoutePath.LOGIN));
    }
  }, [isAdmin, navigate]);

  const onGoToHome = (): void => {
    navigate(isAdmin ? AdminRoutePath.ORGANIZATIONS : RoutePath.ORG_SWITCHER);
  };

  return (
    <NotFoundPageOuterContainer>
      <NotFoundPageInnerContainer>
        <ContentContainer>
          <NotFoundIcon />
          <NotFoundPageTitle data-testid="notFoundPage">404 - Page Not Found</NotFoundPageTitle>
          <NotFoundPageSubTitle>
            The page you are looking for might have been removed, had its name changed or is temporarily unavailable.
          </NotFoundPageSubTitle>
          <div>
            <GoToHomeButton
              onClick={onGoToHome}
              name="Go to Home Page"
              type="submit"
              data-testid="goToHomePageButton"
            />
          </div>
        </ContentContainer>
      </NotFoundPageInnerContainer>
      <Footer />
    </NotFoundPageOuterContainer>
  );
};

export default NotFound;
